// 安心安全メールの過去一覧ページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';
/*-------------------
    cssのimport
---------------------*/
import '../css/safety.css';

// クラス名
class RULE extends Component {
  constructor(props) {
    super(props);

    // URLから安心安全メールのコードを取得。
    const url = props.location.pathname;
    const num = url.lastIndexOf('/');
    const cryptUrl = url.slice(num + 1);
    this.state = { cryptUrl };
  }

  componentDidMount = async () => {
    const { cryptUrl } = this.state;

    // サイト情報を取得する。
    const resData = await commons.siteSetting(cryptUrl);
    const { setting, footer } = resData;

    if (setting === true) return;
    if (setting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const { site_info: siteInfo, lcl_gov: lclGov } = setting[0];
    const { lg_cd: lgCd = '' } = lclGov;
    const { name: siteName = '' } = siteInfo;

    // アカウント情報を取得する。
    const accountSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_ACCOUNT',
      kind: '2',
    });
    const { account_info: accountInfo } = accountSetting[0];
    const { use_rule: useRule } = accountInfo;

    document.title = `${siteName}`;

    this.setState({ footer, siteName, useRule });
  };

  onClickBtnMove = (path) => {
    const { cryptUrl } = this.state;
    const { history } = this.props;
    history.push({ pathname: `${path}/${cryptUrl}` });
  };

  render() {
    const { siteName, footer = '', useRule = [] } = this.state;

    if (footer === '') return true;

    return (
      <div id="safety-container">
        <div className="safety-back">
          <div className="safety-title">{siteName}</div>
          <div className="safety-content">
            <div className="safety-top">
              <h2>利用規約</h2>
            </div>
            <div className="safety-exposition mt20">
              <ul>{commons.shapedContents(useRule, '1')}</ul>
            </div>
            <div className="safety-fot">
              <button
                type="button"
                className="btnAtag mt20"
                onClick={() => {
                  this.onClickBtnMove('../home');
                }}
              >
                トップページに戻る
              </button>
              {footer}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

RULE.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(RULE);
